import { Box, Chip, MenuItem, Select } from "@mui/material";
import PropTypes from "prop-types";

export const ContentTypeMap = { image: "Image", video: "Video" };

export const NotificationCategory = [
  { id: "alert", name: "Alert" },
  { id: "notification", name: "Notification" },
];

export const NotificationType = [
  { id: "all", name: "All" },
  { id: "push", name: "Push" },
  { id: "in-app", name: "In App" },
];

export const NotificationTypeToggle = ({ value, onChange }) => {
  const options = [
    { value: "text", label: `Text (with emojis)` },
    { value: "image", label: `Text + ${ContentTypeMap["image"]}` },
    { value: "video", label: `Text + ${ContentTypeMap["video"]}` },
  ];

  return (
    <div>
      <label className="f_label">Notification Format</label>
      <div style={{ display: "flex", gap: "10px" }}>
        {options.map((opt) => (
          <label
            key={opt.value}
            style={{
              border: "1px solid #999",
              borderRadius: "8px",
              padding: "8px 16px",
              cursor: "pointer",
              flex: "1",
              textAlign: "center",
              background: value === opt.value ? "#000" : "#fff",
              color: value === opt.value ? "#fff" : "#000",
              fontWeight: value === opt.value ? "600" : "400",
            }}
          >
            <input
              type="radio"
              name="notificationType"
              value={opt.value}
              checked={value === opt.value}
              onChange={() => onChange(opt.value)}
              style={{ display: "none" }}
            />
            {opt.label}
          </label>
        ))}
      </div>
    </div>
  );
};

export const NotificationTypeInputs = ({
  modules,
  style,
  options,
  locationType,
  selectedValue,
  setSelectedValue,
  disabled,
}) => {
  return (
    <Select
      required={locationType === "DisplayLocation"}
      style={{ ...style }}
      disabled={disabled}
      value={selectedValue || ""}
      onChange={(e) => setSelectedValue(e.target.value)}
      renderValue={(value) =>
        value ? (
          <Box
            sx={{ display: "flex", gap: 0.5, overflow: "hidden" }}
            className="noScrollBar"
          >
            <Chip
              label={options.find((item) => item.id === value)?.name}
              color="error"
              sx={{
                borderRadius: "4px",
                "& .MuiChip-label": {
                  color: "white",
                  fontWeight: "bold",
                },
              }}
            />
          </Box>
        ) : (
          <span>Select...</span>
        )
      }
    >
      {options.map((item) => (
        <MenuItem key={item.id} value={item.id}>
          {item.name}
        </MenuItem>
      ))}
    </Select>
  );
};

NotificationTypeInputs.propTypes = {
  modules: PropTypes.any,
  style: PropTypes.any,
  options: PropTypes.any,
  locationType: PropTypes.any,
  selectedValue: PropTypes.any,
  setSelectedValue: PropTypes.any,
  disabled: PropTypes.any,
};
